import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { Center } from "../../../../Models/Center";
import { UpdateDtoWithDto } from "../../../../Models/UpdateDtoResponse";
import { Error } from "../../../../Utils/Errors";
import { useApi } from "../../../../Utils/useApi";

const usePutCenters = () => {
  const [update, setUpdate] = useState<Center>();
  const { response, isLoading } = useApi<UpdateDtoWithDto<Center>[], Center[]>({
    method: "put",
    url: "Legacy/V0/Centers",
    data: update ? [update] : undefined,
    valid: Boolean(update),
    error: Error.PutCenters
  });
  useEffect(() => {
    if (!response) return;
    if (response.length && response[0].isSuccess && response[0].dto) toast.success("Successfully updated the center.");
    else toast.error(`Failed to update the center.${response[0].message ? response[0].message : ""}`);
    setUpdate(undefined);
  }, [response]);

  return { response, isLoading, setUpdate };
};

export default usePutCenters;
